import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import { SharedService } from '../../core/services/shared.service';

@Component({
  selector: 'app-calendar-attribute-picker',
  templateUrl: './calendar-attribute-picker.component.html',
  styleUrls: ['./calendar-attribute-picker.component.scss']
})
export class CalendarAttributePickerComponent implements OnInit {

  @Input() attributeList: any;
  @Input() sectionType: any;
  @Output() attributeSelected: EventEmitter<any> = new EventEmitter();
  selectedValue = null;

  constructor(
    public tippyService: NgxTippyService,
    private _sharedService: SharedService
  ) {
  }

  ngOnInit(): void {
  }

  onOptionSelected(option: any): any {
    const selectedValue = { ...option, dismissable: true };
    this.attributeSelected.emit(selectedValue);
    this.tippyService.destroy(this._sharedService.tippyName);
    if(this._sharedService.refreshAddNewAttributeRow) {
      this._sharedService.initAddAttributeRowBtn();
    }
  }
}
